import { render, staticRenderFns } from "./referencement-web-definition-du-seo-on-page.vue?vue&type=template&id=22fed57a&"
import script from "./referencement-web-definition-du-seo-on-page.vue?vue&type=script&lang=js&"
export * from "./referencement-web-definition-du-seo-on-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports